import React from 'react';
import { MenuDropdownWrapper, MenuLeftWrapper } from './styled';
import { Dropdown, Menu } from 'antd';
import {
  AppstoreOutlined,
  BarChartOutlined,
  MessageOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { useAppSelector } from 'app/store';
import { _removeToken } from 'utils/cookie-token';
import { useNavigate } from 'react-router';

function MenuLeft() {
  const navigate = useNavigate();
  const { userInfo } = useAppSelector((state) => state.common);

  const handleLogout = () => {
    _removeToken();
    navigate('/login', { replace: true });
  };

  const menu = (
    <MenuDropdownWrapper className="bg-white">
      <div className="flex p-6">
        <div className="w-11 h-11 rounded-md overflow-hidden">
          <img
            src={
              userInfo.avatar ||
              'https://preview.keenthemes.com/metronic8/demo1/assets/media/avatars/300-1.jpg'
            }
            alt="avatar"
          />
        </div>
        <div className="ml-2">
          <div className="text-base font-semibold">{userInfo.username}</div>
          <div className="text-gray-500 text-sm">{userInfo.email}</div>
        </div>
      </div>
      <Menu
        className="shadow-none pl-6 pr-6 m-0"
        items={[
          {
            key: '1',
            label: 'Thông tin cá nhân'
          },
          {
            key: '2',
            label: 'Thông tin dự án'
          },
          {
            key: '3',
            label: 'My subscription',
            children: [
              {
                key: '3-1',
                label: 'Referral'
              },
              {
                key: '3-2',
                label: 'Billing'
              }
            ]
          }
        ]}></Menu>
      <div className="divide-y-2"></div>
      <Menu
        className="shadow-none pl-6 pr-6 m-0"
        items={[
          {
            key: '4',
            label: (
              <div className="inline-flex justify-between">
                <div>Language</div>Viet Nam<div></div>
              </div>
            ),
            children: [
              {
                key: '4-1',
                label: 'Viet Nam'
              },
              {
                key: '4-2',
                label: 'United State'
              },
              {
                key: '4-3',
                label: 'France'
              },
              {
                key: '4-4',
                label: 'Korea'
              }
            ]
          },
          {
            key: '5',
            label: 'Cài đặt tài khoản'
          },
          {
            key: '6',
            label: <span onClick={handleLogout}>Đăng xuất</span>
          }
        ]}></Menu>
    </MenuDropdownWrapper>
  );

  return (
    <MenuLeftWrapper>
      <div className="menu-left__item">
        <SearchOutlined className="text-muted" />
      </div>
      <div className="menu-left__item">
        <BarChartOutlined className="text-muted" />
      </div>
      <div className="menu-left__item">
        <MessageOutlined className="text-muted" />
      </div>
      <div className="menu-left__item">
        <AppstoreOutlined className="text-muted" />
      </div>
      <div className="menu-left__item menu-left__item--info">
        <Dropdown overlay={menu}>
          <img
            src={
              userInfo.avatar ||
              'https://preview.keenthemes.com/metronic8/demo1/assets/media/avatars/300-1.jpg'
            }
            alt="avatar"
          />
        </Dropdown>
      </div>
    </MenuLeftWrapper>
  );
}

export default MenuLeft;
